import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { ShoppingCart } from "lucide-react"

const orderSchema = z.object({
  telegram_id: z.string().min(1, "Telegram ID is required"),
  plan_id: z.string().min(1, "Plan ID is required"),
  amount: z.number().min(0, "Amount must be positive"),
  order_id: z.string().min(1, "Order ID is required"),
  status: z.enum(["pending", "paid", "cancelled", "expired"]),
})

const orderColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "user_id", type: "text", options: { label: "User ID" } },
  { key: "telegram_id", type: "text", options: { label: "Telegram ID" } },
  { key: "plan_id", type: "text", options: { label: "Plan ID" } },
  { key: "amount", type: "number", options: { label: "Amount" } },
  { key: "order_id", type: "text", options: { label: "Order ID" } },
  { key: "status", type: "status", options: { label: "Status" } },
  { key: "created_at", type: "date", options: { label: "Created" } },
]

const orderFormFields = [
  { name: "telegram_id", label: "Telegram ID", type: "text", placeholder: "Enter Telegram ID" },
  { name: "plan_id", label: "Plan ID", type: "text", placeholder: "Enter Plan ID" },
  { name: "amount", label: "Amount", type: "number", placeholder: "Enter amount" },
  { name: "order_id", label: "Order ID", type: "text", placeholder: "Enter Order ID" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "pending", label: "Pending" },
      { value: "paid", label: "Paid" },
      { value: "cancelled", label: "Cancelled" },
      { value: "expired", label: "Expired" },
    ],
  },
]

export default function OrdersPage() {
  return (
    <ResourcePage
      resource="pricing/purchases"
      title="Orders"
      icon={ShoppingCart}
      columns={orderColumns}
      formFields={orderFormFields}
      formSchema={orderSchema}
    />
  )
}
